
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/design-system/shared-prize-carousel",
      function () {
        return require("private-next-pages/design-system/shared-prize-carousel.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/design-system/shared-prize-carousel"])
      });
    }
  